import JsBarcode from 'jsbarcode';

export type BarcodeSymbology = 'CODE128' | 'CODE39';

/** Alto máximo del código de barras (mm). Compacto para caber con texto 10pt en 11 mm. */
export const LABEL_BARCODE_SVG_MAX_HEIGHT_MM = 3.5;

/**
 * JsBarcode impresión: module width sized for the barcode zone without CSS stretch.
 * Horizontal coverage comes from JsBarcode `width`, not `preserveAspectRatio=none`.
 */
export const LABEL_BARCODE_PRINT_JS_OPTIONS = {
  width: 1.35,
  height: 26,
} as const;

/** JsBarcode miniatura en pantalla (proporcional). */
export const LABEL_BARCODE_PREVIEW_JS_OPTIONS = {
  width: 1.1,
  height: 24,
} as const;

const BARCODE_ASPECT_RATIO = 'xMidYMid meet';

/**
 * Renders CODE128 (default) onto an SVG element. Value must match productCodeUnique for scanners.
 * Preserves aspect ratio so bar module widths stay scannable.
 */
export function renderBarcodeSvg(
  svgEl: SVGSVGElement | null,
  value: string,
  options?: { format?: BarcodeSymbology; width?: number; height?: number },
): void {
  if (!svgEl || !value?.trim()) return;
  while (svgEl.firstChild) {
    svgEl.removeChild(svgEl.firstChild);
  }
  try {
    JsBarcode(svgEl, value, {
      format: options?.format ?? 'CODE128',
      width: options?.width ?? 0.85,
      height: options?.height ?? 28,
      displayValue: false,
      margin: 0,
      background: '#ffffff',
      lineColor: '#000000',
    });
    svgEl.setAttribute('preserveAspectRatio', BARCODE_ASPECT_RATIO);
  } catch {
    /* invalid data for symbology — leave svg empty */
  }
}

/** Inline SVG string for print HTML (no script needed in print window). */
export function barcodeToSvgString(
  value: string,
  options?: { format?: BarcodeSymbology; width?: number; height?: number },
): string {
  if (!value?.trim()) return '';
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  try {
    JsBarcode(svg, value, {
      format: options?.format ?? 'CODE128',
      width: options?.width ?? 0.75,
      height: options?.height ?? 26,
      displayValue: false,
      margin: 0,
      background: '#ffffff',
      lineColor: '#000000',
    });
  } catch {
    return '';
  }
  // Keep uniform module widths — scanners reject non-uniform CODE128 stretch.
  svg.setAttribute('preserveAspectRatio', BARCODE_ASPECT_RATIO);
  return svg.outerHTML;
}
